/*
 * schedulingConstants.ts
 * Contains the shared constants of the scheduling feature, such as the
 * selectable soft and glossy colors which are used for appointments, activities and job types.
 */

// Set the selectable colors of the scheduling events
export const SCHEDULING_COLOR_OPTIONS = [
    { value: "soft-dark-blue", name: "soft-dark-blue" },
    { value: "soft-blue", name: "soft-blue" },
    { value: "soft-dark-green", name: "soft-dark-green" },
    { value: "soft-green", name: "soft-green" },
    { value: "soft-yellow", name: "soft-yellow" },
    { value: "soft-orange", name: "soft-orange" },
    { value: "soft-red", name: "soft-red" },
    { value: "soft-gray", name: "soft-gray" },
    { value: "soft-dark-gray", name: "soft-dark-gray" },
    { value: "soft-purple", name: "soft-purple" },
];

// Set the selectable glossy colors of the scheduling events, in the same
// order as the soft colors so both rows of the color picker line up
export const SCHEDULING_GLOSSY_COLOR_OPTIONS = [
    { value: "general-dark-blue", name: "general-dark-blue" },
    { value: "general-blue", name: "general-blue" },
    { value: "general-dark-green", name: "general-dark-green" },
    { value: "general-green", name: "general-green" },
    { value: "general-yellow", name: "general-yellow" },
    { value: "general-orange", name: "general-orange" },
    { value: "general-red", name: "general-red" },
    { value: "general-gray", name: "general-gray" },
    { value: "general-dark-gray", name: "general-dark-gray" },
    { value: "general-purple", name: "general-purple" },
];

// Set the minimum height of a resource row in the stacked employee scheduler.
// In compact mode every event gets exactly this height, so events are stacked
// below each other instead of being squeezed into a share of the row
export const MIN_RESOURCE_ROW_HEIGHT = 30;

// Set the number of resources from which the scheduler switches to compact
// mode, also when there is still enough screen height available
export const COMPACT_MODE_RESOURCE_COUNT = 20;

// Set the minimum duration in minutes an event is rendered with on the
// timeline, so tiny events stay visible and clickable
export const MIN_EVENT_RENDER_MINUTES = 5;

// Set the minimum duration in minutes an appointment can be resized to
export const MIN_RESIZE_MINUTES = 15;
